
const LOW_PRIORITY = 500;

export default class RemovePropertiesProvider {

  constructor(propertiesPanel) {

    this.getGroups = function (element) {
      return function (groups) {
        // S'il existe un groupe avec l'id "error", on le supprime
        const errorGroup = groups.find(group => group.id === 'error');
        if (errorGroup) {
          groups.splice(groups.indexOf(errorGroup), 1);
        }
        return groups;
      };
    };

    // Use a lower priority to ensure it is loaded after the basic BPMN properties.
    propertiesPanel.registerProvider(LOW_PRIORITY, this);
  }
}

RemovePropertiesProvider.$inject = [ 'propertiesPanel' ];
